<template lang="pug">
Fragment(v-if='isShow')
  transition(name="modal-component")
    div.modal-component__overlay(@click.self='closeModal')
      slot(name='content')

</template>
<script>
import { Fragment } from 'vue-fragment';

export default {
  name: 'ModalWrapper',
  components: {
    Fragment
  },
  props: {
    isShowProps: {
      type: Boolean,
      default: () => false
    }
  },
  data: function () {
    return {
      isShow: false
    };
  },
  watch: {
    isShowProps: function (newValue, oldValue) {
      this.isShow = newValue;
    }
  },
  created: function () {
    this.isCloseButton = this.isCloseButtonProps;
  },
  methods: {
    closeModal: function () {
      this.isShow = false;
      this.$emit('closeModal');
    }
  }
};
</script>
